
  import React from 'react'
  import { MDXTag } from '@mdx-js/tag'
  import NextSteps from '../components/nextSteps/NextSteps';

const layoutProps = {
  
};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = null
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             
             components={components}>
<MDXTag name="h1" components={components}>{`Rate Limits`}</MDXTag>
<MDXTag name="p" components={components}>{`By default, Eventbrite enforces a rate limit on API calls for all integrated
applications.`}</MDXTag>
<MDXTag name="h3" components={components}>{`The default limit is:`}</MDXTag>
<MDXTag name="ul" components={components}>
<MDXTag name="li" components={components} parentName="ul"><MDXTag name="strong" components={components} parentName="li">{`2,000 calls/hour`}</MDXTag></MDXTag>
<MDXTag name="li" components={components} parentName="ul"><MDXTag name="strong" components={components} parentName="li">{`48,000 calls/day`}</MDXTag></MDXTag>
</MDXTag>
<MDXTag name="h3" components={components}>{`Event Action limits:`}</MDXTag>
<MDXTag name="ul" components={components}>
<MDXTag name="li" components={components} parentName="ul"><MDXTag name="strong" components={components} parentName="li">{`Create and Copy Event:`}</MDXTag>{` 200 calls/hour`}</MDXTag>
<MDXTag name="li" components={components} parentName="ul"><MDXTag name="strong" components={components} parentName="li">{`Publish Event:`}</MDXTag>{` 200 calls/hour`}</MDXTag>
<MDXTag name="li" components={components} parentName="ul"><MDXTag name="strong" components={components} parentName="li">{`Create Event Schedule:`}</MDXTag>{` 200 calls/hour`}</MDXTag>
</MDXTag>
<NextSteps
    steps={[
        {
            title: 'App OAuth Flow',
            link: '/platform/docs/app-oauth-flow',
        },
        {
            title: 'Embedding a Checkout Flow',
            link: '/platform/docs/embedded-checkout',
        },
    ]}
/>
           </MDXTag>
  }
}
  